import React from "react";
import Head from "../../football/match/Head";
import BasketballInfoTable from "../../basketball/BasketballInfoTable";
import BasketballStats from "../../basketball/BasketballStats";
import BasketballLineup from "../../basketball/BasketballLineup";
import BasketballH2H from "../../basketball/BasketballH2H";
import BasketballMatchTable from "../../basketball/BasketballMatchTable";
import BasketballScoring from "../../basketball/BasketballScoring";

const BasketballMatchWidgetWrap = (props) => {
  const {
    dataId,
    dataType,
    head,
    data,
    headData,
    sport,
    difference,
    loadCSS,
    dataClient,
    websiteBaseUrl,
    dataPath,
    dataTitle,
    socketUrl,
    channel,
    event,
  } = props;

  const renderHeadWrap = (currentTab, children) =>
    head ? (
      <Head
        matchDetail={headData}
        difference={difference}
        sport={sport}
        dataClient={dataClient}
        id={dataId}
        currentTab={currentTab}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        title={dataTitle}
        socketUrl={socketUrl}
        channel={channel}
        event={event}
      >
        {children}
      </Head>
    ) : (
      <>{children}</>
    );

  switch (dataType) {
    case "basketball-match-info":
      return renderHeadWrap("info",
        <BasketballInfoTable
          ServerData={data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          difference={difference}
          title={dataTitle}
          sport={sport}
        />
      );
    case "basketball-match":
      return (head && (<Head
        matchDetail={headData}
        difference={difference}
        sport={sport}
        dataClient={dataClient}
        id={dataId}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        title={dataTitle}
      />));
    case "basketball-match-stats":
      return renderHeadWrap("stats",
        <BasketballStats
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
        />
      );
    case "basketball-match-lineup":
      return renderHeadWrap("lineup",
        <BasketballLineup
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
        />
      );
    case "basketball-match-h2h":
      return renderHeadWrap("h2h",
        <BasketballH2H
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
          sport={sport}
        />
      );
    case "basketball-match-table":
      return renderHeadWrap("table",
        <BasketballMatchTable
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
          sport={sport}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
        />
      );
    case "basketball-match-scoring":
      return renderHeadWrap("scorings",
        <BasketballScoring
          data={data?.data}
          loadCSS={loadCSS}
          dataClient={dataClient}
          title={dataTitle}
          sport={sport}
        />
      );
    default:
      return <h1>Basketball Match Widget Not Found!</h1>;
  }
};

export default BasketballMatchWidgetWrap;
